import jwtAuthAxios from "../auth/jwtAuth";

// Límites de seguridad: mientras una variable está fuera de límite, sus salidas quedan en el estado seguro.
const safetyLimitServices = {};

safetyLimitServices.getSafetyLimit = async (id) => {
    const { data } = await jwtAuthAxios.get(`/automations/safety_limits/${id}`);
    return data;
};

safetyLimitServices.getEditOptions = async () => {
    const { data } = await jwtAuthAxios.get("/automations/safety_limits/edit_options");
    return data;
};

safetyLimitServices.createSafetyLimit = async (safetyLimit) => {
    const { data } = await jwtAuthAxios.post("/automations/safety_limits", { safety_limit: safetyLimit });
    return data;
};

safetyLimitServices.updateSafetyLimit = async (id, safetyLimit) => {
    const { data } = await jwtAuthAxios.put(`/automations/safety_limits/${id}`, { safety_limit: safetyLimit });
    return data;
};

safetyLimitServices.deleteSafetyLimit = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/automations/safety_limits/${id}`);
    return data;
};

export default safetyLimitServices;
